import foxThemeDark from './fox-dark';

const themes: Record<string, string> = {
  'fox-dark': foxThemeDark
};

export default function (theme?: string): string {
  return (theme && themes[theme]) ?? '';
}
